import type {SVGProps} from 'react'
import * as React from 'react'
const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      d="M10.6456 10.6457C12.4681 8.82325 12.4681 5.86848 10.6456 4.04603C8.8232 2.22359 5.86843 2.22359 4.04598 4.04603C2.22354 5.86848 2.22354 8.82325 4.04598 10.6457C5.86843 12.4681 8.8232 12.4681 10.6456 10.6457ZM10.6456 10.6457L13.1205 13.1206"
      stroke="#9096A3"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)
export default SearchIcon
